import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import { OAuthService } from "tekkr-common/dist/oauth";

interface Input {
    service: OAuthService;
}

export function useLinkOauthAccountMutation() {
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.linkOauthAccount({
                params: {
                    service: input.service,
                },
            });
            const body = res.body as ClientInferResponseBody<typeof apiContract.linkOauthAccount>;
            return body.authUrl;
        },
    });
}
